define('common/views/footer_view_mdfooter',['require','exports','module','base/view','backbone','i18n','react','react-dom','mdfooterjs','ThemesHelper'],function (require, exports, module) {
  'use strict';

  var View = require('base/view'),
    Backbone = require('backbone'),
    i18n = require('i18n'),
    React = require('react'),
    ReactDOM = require('react-dom'),
    MDFooter = require('mdfooterjs'),
    ThemesHelper = require('ThemesHelper');

  var userLang;

  var Footer = Backbone.View.extend({
    initialize: function () {},

    getCurrentLang: function () {
      return i18n.lng().substr(0, 2);
    },

    render: function () {
      var footerOptions = {
        theme: ThemesHelper.getCurrentTheme(),
        lang: userLang || this.getCurrentLang(),
      };

      ReactDOM.render(React.createElement(MDFooter, footerOptions), this.el);
      return this;
    },

    setUserLang: function (lang) {
      userLang = lang;
      return this;
    },

    refresh: function () {
      this.render();
    },
  });

  module.exports = Footer;
});

